import { Card, Typography, Button } from 'antd';
import {
  WalletOutlined,
  StockOutlined,
  RiseOutlined,
  FallOutlined,
  CalendarOutlined,
  FundOutlined,
  BankOutlined,
  FileTextOutlined,
  TrophyOutlined,
  DollarOutlined,
  CreditCardOutlined,
  PercentageOutlined,
  ArrowLeftOutlined,
} from '@ant-design/icons';
import { getInsights, Insight } from '../../../Utils/insightsUtils';
import styles from './index.module.css';

const getIcon = (iconName: string, color: string) => {
  const iconStyle = { fontSize: 20, color };

  switch (iconName) {
    case 'wallet':
      return <WalletOutlined style={iconStyle} />;
    case 'stock':
      return <StockOutlined style={iconStyle} />;
    case 'rise':
      return <RiseOutlined style={iconStyle} />;
    case 'fall':
      return <FallOutlined style={iconStyle} />;
    case 'calendar':
      return <CalendarOutlined style={iconStyle} />;
    case 'fund':
      return <FundOutlined style={iconStyle} />;
    case 'bank':
      return <BankOutlined style={iconStyle} />;
    case 'file':
      return <FileTextOutlined style={iconStyle} />;
    case 'trophy':
      return <TrophyOutlined style={iconStyle} />;
    case 'dollar':
      return <DollarOutlined style={iconStyle} />;
    case 'credit-card':
      return <CreditCardOutlined style={iconStyle} />;
    case 'percentage':
      return <PercentageOutlined style={iconStyle} />;
    default:
      return <WalletOutlined style={iconStyle} />;
  }
};

const InsightItem: React.FC<{ insight: Insight }> = ({ insight }) => {
  return (
    <div className={styles.insightItem}>
      <div
        className={styles.iconContainer}
        style={{ backgroundColor: `${insight.color}15` }}
      >
        {getIcon(insight.icon, insight.color)}
      </div>
      <div className={styles.contentContainer}>
        <Typography.Text className={styles.title}>
          {insight.title}
        </Typography.Text>
        <Typography.Text className={styles.description}>
          {insight.description}
        </Typography.Text>
      </div>
    </div>
  );
};

type InsightsPageProps = {
  onBack: () => void;
};

const InsightsPage: React.FC<InsightsPageProps> = ({ onBack }) => {
  const insightsList = getInsights();

  return (
    <div className={styles.insightsPage}>
      <div className={styles.pageHeader}>
        <Button
          type='text'
          icon={<ArrowLeftOutlined />}
          onClick={onBack}
          className={styles.backButton}
        />
        <Typography.Title level={4} style={{ margin: 0 }}>
          All Financial Insights
        </Typography.Title>
      </div>
      <Card className={styles.insightsPageCard}>
        <div className={styles.insightsList}>
          {insightsList.map((insight) => (
            <InsightItem key={insight.id} insight={insight} />
          ))}
        </div>
        {insightsList.length === 0 && (
          <div className={styles.emptyState}>
            <Typography.Text>No insights available</Typography.Text>
          </div>
        )}
      </Card>
    </div>
  );
};

export default InsightsPage;
